import React, { useState, useEffect } from 'react';
import apiFetch from '../../../../utils/api';
import Preloader from '../../../../components/Preloader/Preloader';
import Pagination from '../../../../components/Pagination/Pagination';
import './AdminStyles.css';

const AdminPendingPins = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [acting, setActing] = useState(null);
  const [viewImage, setViewImage] = useState(null);

  const fetchData = () => {
    setLoading(true);
    apiFetch(`/api/admin/pins/pending?page=${page}`)
      .then(res => res.json())
      .then(res => { 
        setData(res.requests || []); 
        setTotalPages(res.totalPages || 1);
        setTotalCount(res.totalCount || 0);
        setLoading(false); 
      })
      .catch(() => setLoading(false));
  };

  useEffect(fetchData, [page]);

  const handleAction = async (id, action) => {
    setActing(id);
    try {
      const res = await apiFetch(`/api/admin/pins/${id}/action`, {
        method: 'POST',
        body: JSON.stringify({ action }),
      });
      const result = await res.json();
      if (result.success) {
        fetchData();
      }
    } catch (err) { console.error(err); }
    setActing(null);
  };

  return (
    <div className="admin-page">
      <div className="admin-breadcrumb">🏠 / Admin / Pending E-Pin Requests</div>
      <h2 className="admin-title">Pending E-Pin Requests</h2>

      <div className="admin-stats-bar">
        <div className="admin-stat-chip orange">{totalCount} Pending</div>
      </div>

      <div className="admin-card">
        <div className="admin-card-header">Pin Requests Awaiting Approval</div>
        <div className="admin-card-body">
          {loading ? (
            <Preloader message="Fetching pending pin requests..." fullScreen={false} />
          ) : data.length === 0 ? (
            <div className="admin-empty">No pending pin requests</div>
          ) : (
            <>
              <div className="admin-table-wrap">
                <table className="admin-table">
                  <thead>
                    <tr>
                      <th>ID</th><th>Username</th><th>Account #</th><th>TRX ID</th>
                      <th>Qty</th><th>Amount</th><th>Date</th><th>Attachment</th><th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.map(row => (
                      <tr key={row.id}>
                        <td>{row.id}</td>
                        <td>{row.username}</td>
                        <td>{row.accountNumber || <span style={{ color: 'var(--awp-text-subtle)' }}>—</span>}</td>
                        <td>{row.trxId || <span style={{ color: 'var(--awp-text-subtle)' }}>—</span>}</td>
                        <td><span className="admin-stat-chip blue" style={{ padding: '2px 8px', fontSize: 12 }}>{row.quantity}</span></td>
                        <td>Rs. {row.amount}</td>
                        <td>{row.createdAt}</td>
                        <td>
                          {row.screenshot ? (
                            <button 
                              className="admin-btn admin-btn--edit" 
                              onClick={() => setViewImage(row.screenshot)}
                              title="View Screenshot"
                            >
                              👁 View
                            </button>
                          ) : (
                            <span style={{ color: 'var(--awp-text-subtle)', fontSize: 12 }}>None</span>
                          )}
                        </td>
                        <td>
                          <div className="admin-actions-row">
                            <button className="admin-btn admin-btn--approve" disabled={acting === row.id} onClick={() => handleAction(row.id, 'approve')}>Approve</button>
                            <button className="admin-btn admin-btn--reject" disabled={acting === row.id} onClick={() => handleAction(row.id, 'reject')}>Reject</button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <Pagination 
                currentPage={page} 
                totalPages={totalPages} 
                onPageChange={setPage} 
              />
            </>
          )}
        </div>
      </div>
      {/* Image Modal */}
      {viewImage && (
        <div className="admin-modal-overlay" onClick={() => setViewImage(null)}>
          <div className="admin-modal" onClick={e => e.stopPropagation()} style={{ maxWidth: '600px', p: 0 }}>
            <div className="admin-modal-header">
              <h3>Payment Proof</h3>
              <button className="admin-modal-close" onClick={() => setViewImage(null)}>✕</button>
            </div>
            <div style={{ padding: '0', textAlign: 'center', maxHeight: '70vh', overflow: 'auto' }}>
              <img src={viewImage} alt="Payment Proof" style={{ maxWidth: '100%', height: 'auto', display: 'block' }} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminPendingPins;
